<template>
    <div class="col-12 col-md-12">
        <div class="form-group">
            <label for="medicare-part-a-effective-date"> Medicare Part A Effective Date </label>
            <DatePicker :getDate="onDateChange">
                <div class="input-group date datepickerInput">
                    <input
                        type="text"
                        name="medicare-part-a-effective-date"
                        class="form-control"
                        :value="formatDateInput(referral.ReferralExtension[insurer?.partADate])"
                        @change="handleDateChange"
                        placeholder="MM/DD/YYYY"
                        autocomplete="off"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </div>
        <div class="form-group">
            <label for="medicare-part-b-effective-date"> Medicare Part B Effective Date </label>
            <DatePicker :getDate="onDateChange">
                <div class="input-group date datepickerInput">
                    <input
                        type="text"
                        name="medicare-part-b-effective-date"
                        class="form-control"
                        :value="formatDateInput(referral.ReferralExtension[insurer?.partBDate])"
                        @change="handleDateChange"
                        placeholder="MM/DD/YYYY"
                        autocomplete="off"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </div>
        <div class="form-group">
            <b class="me-2">Existing Prior Episodes:</b>
            <div class="form-group col-12 py-2">
                <div class="col-12 row">
                    <input
                        v-model="referral.ReferralExtension[insurer?.priorEpisode]"
                        :value="1"
                        name="existing-prior-episode"
                        type="radio"
                        au-target-id="791"
                        id="within-sixty-days"
                    />
                    <label for="within-sixty-days" class="col-10">
                        Patient within their sixty-day period on OUR <br />
                        services.
                    </label>
                </div>
                <div class="col-12 row">
                    <input
                        v-model="referral.ReferralExtension[insurer?.priorEpisode]"
                        :value="2"
                        name="existing-prior-episode"
                        type="radio"
                        au-target-id="791"
                        id="service-with-another-agency"
                    />
                    <label for="service-with-another-agency" class="col-10">
                        Patient on services with Another Agency. Need Beneficiary Transfer Statement.
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./MedicarePayorNew.ts"></script>
